var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"NotFound__Wrapper"},[_c('span',{staticClass:"md-display-2",staticStyle:{"width":"100%"}},[_vm._v("\n      "+_vm._s(_vm.$t('message.pagina_inexistente'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('message.redirecionando_para_home'))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/spa/NotFound.vue?vue&type=template&id=6ee8c274&lang=html&
// module id = 964
// module chunks = 28